export const permissionsMixin = {
  methods: {
    searchPermissionByName(permissionsUser, name) {
      const indexItemPermissions = permissionsUser.findIndex(
        (v) => v.name === name,
      )
      // It means permission for this page has not been set yet for the customer
      if (indexItemPermissions === -1) {
        return null
      }
      return permissionsUser[indexItemPermissions]
    },
    searchReadPermissionByName(permissionsUser, name) {
      const indexItemPermissions = permissionsUser.findIndex(
        (v) => v.name === name,
      )
      // It means permission for this page has not been set yet for the customer
      if (indexItemPermissions === -1) {
        return null
      }
      const { permissions } = permissionsUser[indexItemPermissions]
      const readPermission = permissions.find(
        (permission) => permission.name === 'read',
      )
      return readPermission
    },
    searchReadPermissionByRouteName(permissionsUser, path) {
      const indexItemPermissions = permissionsUser.findIndex((v) =>
        v.pathNames.includes(path),
      )
      // It means permission for this page has not been set yet for the customer
      if (indexItemPermissions === -1) {
        return null
      }
      const { permissions } = permissionsUser[indexItemPermissions]
      const readPermission = permissions.find(
        (permission) => permission.name === 'read',
      )
      return readPermission
    },
  },
}
